import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@16.3.0_@babel+core@7.29.0_supports-color@8.1.1__@types+node@25.3.5_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@16.3.0_@babel+core@7.29.0_supports-color@8.1.1__@types+node@25.3.5_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@16.3.0_@babel+core@7.29.0_supports-color@8.1.1__@types+node@25.3.5_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@16.3.0_@babel+core@7.29.0_supports-color@8.1.1__@types+node@25.3.5_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager", webpackExports: ["Carousel"] */ "/vercel/path0/src/components/common/interaction/Carousel/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/common/layout/Image/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/common/layout/Section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Video"] */ "/vercel/path0/src/components/common/layout/Video.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/common/storyblok/Button.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/common/typography/RichText/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FilmCategoryCarousel"] */ "/vercel/path0/src/components/modules/sections/FilmCategoryCarousel.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/modules/sections/HeroMedia.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/modules/sections/RichTextSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SiteHeader"] */ "/vercel/path0/src/components/modules/site/SiteHeader.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/modules/site/StoryblokPreviewBridge.tsx");
